import axios from "axios";

// Backend is reached via the SAME ORIGIN that serves the frontend. The Emergent
// ingress (preview, production deploy, and custom domains) routes every
// `/api/*` request to the FastAPI pod, so a relative path works in all
// environments and avoids the classic "REACT_APP_BACKEND_URL was baked at
// build time and points to the wrong host after deploy" issue.
export const API_BASE = "/api";

export const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("b2b_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}

export function formatMoney(n, nativeHuf) {
  if (n == null || isNaN(n)) return "—";
  // Read the active currency from the mirror set by CurrencyProvider. We
  // intentionally avoid importing the React context here so this helper stays
  // a plain function usable outside components.
  const state = (typeof globalThis !== "undefined" && globalThis._b2bCurrency) || {};
  const currency = state.currency || "EUR";
  const rateHuf = Number(state.rateHuf) || 400;
  const val = Number(n);
  if (currency === "HUF") {
    // Marketplace items imported from a Forint pricelist snapshot the
    // exact HUF value the admin uploaded. Use it verbatim so the customer
    // never sees a ±1 Ft drift caused by the EUR round-trip.
    if (nativeHuf != null && Number(nativeHuf) > 0) {
      return `${Math.round(Number(nativeHuf)).toLocaleString("hu-HU")} Ft`;
    }
    return `${Math.round(val * rateHuf).toLocaleString("hu-HU")} Ft`;
  }
  return `€${val.toFixed(2)}`;
}

/**
 * Format a money value that has already been recorded in a specific currency
 * (orders snapshot the customer's chosen currency at checkout). Use this for
 * order detail / receipt views, where the canonical EUR figure is wrong if
 * the order was placed in HUF.
 *
 * @param {number} n        Amount in the order's recorded currency.
 * @param {string} currency "EUR" or "HUF" — defaults to EUR for legacy orders.
 */
export function formatOrderMoney(n, currency) {
  if (n == null || isNaN(n)) return "—";
  const val = Number(n);
  const cur = (currency || "EUR").toUpperCase();
  if (cur === "HUF") return `${Math.round(val).toLocaleString("hu-HU")} Ft`;
  return `€${val.toFixed(2)}`;
}
